/**
 * This file is part of the Keycloak authentication experiment.
 *
 * The component exported by this file is a temporary measure
 * that prevents the authentication system from kicking in
 * until the Flagsmith server has given us the current
 * value of the feature flag.
 *
 * Don't reuse this, please. Flags should be async.
 *
 * This file and component will be removed once the
 * Keycloak authentication server is available in
 * all environments.
 */
import React from 'react';
import { useFlags, useFlagsmithLoading } from '@flagsmith/flagsmith/react';
import { setKeycloakAuthMode } from './authentication';

export const useKeycloakAuthFlagName = 'res.chichon.use-keycloak-auth';

export function AuthenticationFeatureSwitch({ children }) {
    const {
        isLoading,
        isFetching,
    } = useFlagsmithLoading();

    if (isFetching || isLoading) {
        return (
            <p>Waiting for authentication adapter to be selected...</p>
        )
    }

    return children;
}

export function useKeycloakFeatureFlag() {
    const flags = useFlags([ useKeycloakAuthFlagName ]);
    const { enabled } = flags[useKeycloakAuthFlagName];

    setKeycloakAuthMode(enabled);

    return {
        useLegacy: !enabled,
        useKeycloak: enabled,
    };
}
